


































import { Component, Watch, PropSync, Prop, InjectReactive } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
import questionnaireEditorCore from "./questionnaireEditorCore.vue";
import questionnaireEditorActions from "./questionnaireEditorActions.vue";

type ResolveFunction = (value?: any) => void;
type RejectFunction = (reason?: any) => void;

interface EditorState {
  activeIndex: number;
  isAnswerMode: boolean;
  isViewMode: boolean;
  submitLoading: boolean;
}

@Component({
  name: "addSurveyForActivityDialog",
  components: { questionnaireEditorCore, questionnaireEditorActions },
})
export default class addSurveyForActivityDialog extends mixins(commonMixins) {
  @PropSync("modalVisible", { type: Boolean })
  visible!: boolean;

  @InjectReactive()
  surveyType!: string;

  @Prop({ default: "" })
  questionnaireId?: string;

  @Prop({ default: "" })
  templateId?: string;

  @Prop({ default: "ADD" })
  openMode?: string;

  @Prop({ default: () => ({}) })
  success!: (result: string | number | object) => void;

  @Prop({ default: () => ({}) })
  templateSuccess!: (result: string | number | object) => void;

  @Prop({ default: "" })
  editSpecialMode?: string;

  @Prop({ default: "QUESTIONNAIRE" })
  activityQuestionnaireType?: string;

  @Prop({ default: "QUESTIONNAIRE" })
  activityQuestionnaireProperty?: string;

  @Prop({ default: false })
  showVerificationConfig?: boolean;

  @Prop({
    default: () => {
      return {
        title: "自定义表单",
        label: "表单名称",
        type: "ACTIVITY",
      };
    },
  })
  surveyConfig?: any;

  private editorState: EditorState = {
    activeIndex: 1,
    isAnswerMode: false,
    isViewMode: false,
    submitLoading: false,
  };
  private resolve: ResolveFunction | null = null;
  private reject: RejectFunction | null = null;

  get hasEditSpecialMode() {
    return Boolean(this.editSpecialMode);
  }

  @Watch("visible")
  inputValChange(visible: boolean) {
    if (visible) {
      this.handleDialogOpen();
    } else {
      this.handleDialogClose();
    }
  }

  private getEditorCore() {
    return this.$refs.editorCore as any;
  }

  // 弹窗层只处理显示生命周期，问卷初始化交给核心层
  handleDialogOpen() {
    this.$nextTick(() => {
      const editorCore = this.getEditorCore();
      editorCore && editorCore.initQuestionnaire();
    });
  }

  handleDialogClose() {
    const editorCore = this.getEditorCore();
    editorCore && editorCore.clearValidate();
    typeof this.reject === "function" && this.reject();
  }

  handleCancel() {
    this.visible = false;
    if (typeof this.reject === "function") {
      this.reject(new Error("用户取消"));
    }
    this.$emit("cancel");
  }

  handleClose() {
    if (typeof this.reject === "function") {
      this.reject(new Error("弹窗关闭"));
    }
    this.$emit("close");
  }

  handleStateChange(state: EditorState) {
    this.editorState = state;
  }

  handleSuccess(result: any) {
    this.$emit("success", result);
    this.success && typeof this.success === "function" && this.success(result);
    typeof this.resolve === "function" && this.resolve();
  }

  handleTemplateSuccess(templateId: any) {
    this.$emit("templateSuccess", templateId);
    this.templateSuccess && typeof this.templateSuccess === "function" && this.templateSuccess(templateId);
  }

  handlePreview() {
    this.getEditorCore().saveTemp();
  }

  handlePrevious() {
    this.getEditorCore().preNextClick();
  }

  handleNext() {
    this.getEditorCore().nextStep();
  }

  handleSubmitTemplate() {
    this.getEditorCore().nextStepToTemple();
  }

  handleSubmit() {
    this.getEditorCore().nextStep();
  }

  // 保留原有命令式打开方式和 Promise 返回契约
  open() {
    if (this.visible) {
      this.handleDialogOpen();
    } else {
      this.visible = true;
    }
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
